import React from 'react'

import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

import { BaseDialog } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import theme from 'theme'
import * as service from 'service'
import helpers from 'helpers'

const DeleteAiInventoryModal = ({ open, setOpen, refresh, aiInventoryId }) => {
  const snackbar = useSnackbar()

  const onSubmit = async (event) => {
    event.preventDefault()

    try {
      await service.dponet.aiInventory.destroy(aiInventoryId)

      snackbar.open({
        message: 'Inventário de IA excluído com sucesso!',
        variant: 'success',
      })
      refresh()
      setOpen(false)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro ao excluir o inventário de IA.',
        variant: 'error',
      })
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Excluir Inventário de IA"
      actionButtonText="Excluir"
      closeButtonText="Cancelar"
      formRef="ai-inventory-destroy-form"
    >
      <Box
        component="form"
        id="ai-inventory-destroy-form"
        onSubmit={onSubmit}
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
      >
        <Typography variant="h6">
          Tem certeza que deseja excluir este inventário de IA?
        </Typography>
        <Typography>Não será possível desfazer essa ação!</Typography>
      </Box>
    </BaseDialog>
  )
}

DeleteAiInventoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  aiInventoryId: PropTypes.number.isRequired,
}

export default DeleteAiInventoryModal
